@if(ventureDetails(); as venture){
<div class="acc-venture-details-dialog-part row h-100">
	<div class="col-lg-6">
		<div class="bg-light rounded shadow-sm d-flex flex-column justify-content-between h-100">
			<div>
				<div class="pt-2 ps-1">
					<h5>
						<span class="badge bg-secondary-subtle text-black px-3 py-2">
							Status: {{venture.status}}
						</span>
					</h5>
				</div>

				<div class="p-2 pt-0">
					<div>
						<div class="d-flex">
							<div class="me-2">Venture:</div>
							<div>{{venture.ventureName}}</div>
						</div>
						<div class="d-flex">
							<div class="me-2">Entrepreneurs:</div>
							<div>{{venture.entrepreneurs}}</div>
						</div>
					</div>

					@if(venture.dropout; as dropout){
					<div class="mt-3">
						<div class="d-flex">
							<div class="me-2">Dropout Week:</div>
							<div>{{dropout.dropoutWeek}}</div>
						</div>
						<div class="d-flex">
							<div class="me-2">Dropout Reason:</div>
							<div>{{dropout.dropoutReason}}</div>
						</div>
						<div class="d-flex">
							<div class="me-2">Dropped by:</div>
							<div>{{dropout.droppedOutByStaff}}</div>
						</div>
						<div class="d-flex">
							<div class="me-2">Dropout Notes:</div>
							<div>{{dropout.notes}}</div>
						</div>
					</div>
					}

					<div class="mt-3">
						<div class="d-flex">
							<div class="me-2">Business Type:</div>
							<div>{{venture.businessType}}</div>
						</div>
						<div class="d-flex">
							<div class="me-2">Industry:</div>
							<div>{{venture.industry}}</div>
						</div>
						<div class="d-flex">
							<div class="me-2">Offerings:</div>
							<div>{{venture.offerings}}</div>
						</div>
						<div class="d-flex">
							<div class="me-2">Operation Status:</div>
							<div>{{venture.operatingStatus}}</div>
						</div>
					</div>

					<div class="mt-3">
						<div class="d-flex">
							<div class="me-2">Goals:</div>
							<div>{{venture.goalsCount}}</div>
						</div>
						<div class="d-flex">
							<div class="me-2">Course completion:</div>
							<div>{{venture.courseCompletionPercentage}}%</div>
						</div>
					</div>

					<div class="mt-3">
						<div class="d-flex">
							<div class="me-2">Last Updated:</div>
							<div>{{venture.formattedUpdatedDate}}</div>
						</div>
						<div class="d-flex">
							<div class="me-2">Created:</div>
							<div>{{venture.formattedCreatedDate}}</div>
						</div>
					</div>
				</div>
			</div>

			<div class="m-3">
				<common-button-row [center]="true">
					@if(venture.websiteURL){
					<button class="btn btn-standard me-2" (click)="openURL(venture.websiteURL)">Website</button>
					}
					@if(venture.workbookDriveURL){
					<button class="btn btn-standard" (click)="openURL(venture.workbookDriveURL)">Workbook Drive</button>
					}
				</common-button-row>
			</div>

		</div>
	</div>

	<div class="col-lg-6">
		<div class="bg-light rounded shadow-sm p-2 d-flex flex-column h-100">
			<readonly-access [readonly]="!dialogDataService.canEdit()"></readonly-access>
			<div class="d-flex flex-column justify-content-between flex-grow-1">
				<div class="d-flex flex-column gap-3">
					<common-text-field [field]="form.name()"></common-text-field>
					<common-url-field [field]="form.workbookDriveURL()"></common-url-field>
					<common-url-field [field]="form.websiteURL()"></common-url-field>
					<common-number-field [field]="form.workbookScore()"></common-number-field>
				</div>

				@if(dialogDataService.canEdit()){
				<div class="m-3">
					<common-button-row [center]="true">
						<button class="btn btn-standard" #saveBtn>Save</button>
						<button class="btn btn-standard" (click)="form.form.resetAll()">Revert</button>
					</common-button-row>

					<common-button-row [center]="true" class="mt-3">
						<button class="btn btn-standard" (click)="openDropoutDialog()">{{venture.dropout ? 'Edit Dropout' : 'Drop-out Venture'}}</button>
					</common-button-row>
				</div>
				}
			</div>
		</div>
	</div>
</div>
}